export default "__VITE_ASSET__CO8NM9R0__"